
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DASHBOARD_PATH } from 'config';
import { useAuth } from 'context/AuthContext';
import { MAIN_ROLES } from 'config';

const GuestGuard = ({ children }) => {
    const navigate = useNavigate();
    const { authenticated, user } = useAuth();

    useEffect(() => {
        if (authenticated) {
            const hasRoleCheck = () => MAIN_ROLES?.filter(name => user?.rolesName?.includes(name))?.length;
            if (hasRoleCheck()) {
                navigate(DASHBOARD_PATH, { replace: true });
            } else {
                navigate('/projects/project-creation/project-list', { replace: true });
            }
        }
    }, [authenticated, navigate]);

    return children;
};

export default GuestGuard;
